import { useSearchParams } from 'react-router-dom';
import { SubmitHandler, useForm } from 'react-hook-form';
import Layout from '../../../Components/Layout/Layout';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Loader from '../../../Components/Spinner/Loader';
import InputField from '../../../Components/Common/InputField';
import { useMatchOTP } from '../apiEndpoints/commonApiEndpoints';

const MatchOtp = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const type = searchParams.get('type');
  const { register, handleSubmit } = useForm();
  const { mutate, isPending } = useMatchOTP({ email, type });
  const onSubmit: SubmitHandler<any> = async (data: { otp: string }) => {
    mutate({ ...data, type, email });
  };
  return (
    <>
      <Layout
        pathName={
          type === 'forget_fair'
            ? 'Exhibitor'
            : type === 'forget_b2b'
            ? 'Buyer/Seller B2B'
            : type === 'forget_visitor'
            ? 'Visitor'
            : ''
        }
        showHeader
      >
        <div className='login-wrapper'>
          <div className='login-div'>
            <div className='login-page'>
              <h3 className='text-center'>Match OTP</h3>
              <div className='login-form'>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <InputField
                    label=' Enter OTP'
                    register={register('otp')}
                    type='number'
                    isRequired
                    placeholder='Enter OTP'
                  />

                  <div>
                    {isPending ? (
                      <Loader css={'w-100 mt-5 text-white'} />
                    ) : (
                      <Button
                        type='submit'
                        className='w-100 mt-5 submit-button'
                      >
                        Continue
                      </Button>
                    )}
                  </div>

                  <div className='lost-your-password pt-3 fw-bold text-center'>
                    <Link to='/login' className='forget-link'>
                      Go back
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default MatchOtp;
